<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">할인차량관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">할인차량 관리</p>
          <ul class="depth">
            <li><router-link to="/discountvehicle" title="할인차량 관리">할인차량 관리</router-link></li>
            <li><router-link to="/freevehicle" title="무료차량 관리">무료차량 관리</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">할인차량 수정</h3>
        <article>
          <!--table pc-->
          <div class="table horizontal-table">
            <table>
              <caption>
                할인차량 수정 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 60px" />
                <col style="width: 35%" />
                <col style="width: 15%; min-width: 60px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">사용자명</th>
                  <td colspan="3">
                    <input type="text" title="사용자명 입력" class="md" v-model="data.carOwnerNm" />
                    <div class="error" v-if="!$v.data.carOwnerNm.required">이름을 입력해주세요.</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량번호</th>
                  <td colspan="3">
                    <div class="flex">
                      <input type="text" title="사용자명 입력" class="md" v-model="data.carNo" />
                      <button type="button" class="btn gray">중복확인</button>
                    </div>
                    <div class="error" v-if="!$v.data.carNo.required">필수 입력란입니다.</div>
                    <div class="error" v-if="!$v.data.carNo.carNoCheck">차량번호 형식에 맞지 않습니다.</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">할인유형</th>
                  <td>
                    <select v-model="data.discountCd" title="할인유형 선택">
                      <option
                        v-for="(item, index) in discountList"
                        :key="index"
                        :value="item.code"
                      >
                        {{ item.codeNm }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th scope="row">할인기간</th>
                  <td colspan="3">
                    <date-picker :propsDate="{startDate:data.startDt, endDate:data.endDt}" @emitSetDate="emitSetDate"></date-picker>
                  </td>
                </tr>
                <tr>
                  <th scope="row">비고</th>
                  <td colspan="3">
                    <input v-model="data.note" type="text" title="비고 입력" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table pc-->
        </article>
        <article class="btnArea">
          <button type="button" class="btn border" @click="$router.push('discountvehicle')">목록</button>
          <button type="button" class="btn gray" @click="$router.push('discountvehicle')">취소</button>
          <button type="button" class="btn blue" @click="updateBtn">저장</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import DatePicker from '../../../components/DatePicker2.vue';
import { required, helpers, or } from 'vuelidate/lib/validators';
const carNoRegex = helpers.regex('carNoRegex', /^\s*([가-히]{2}){0,1}\s*[0-9]{2,3}[\s]*[가-히]{1}[\s]*[0-9]{4}\s*$/gi);
const carNoRegexDipl = helpers.regex(
  'carNoRegexDipl',
  /^\s*([외교,영사,준외,협정,국기,준영,대표]{2}){0,1}\s*[0-9]{3}[\s]*[-]{1}[\s]*[0-9]{3}\s*$/gi,
);

export default {
  data() {
    return {
      data: !this.$route.params.data ? {} : this.$route.params.data,
      

      discountList: [],
    };
  },

  validations: {
    data: {
      carOwnerNm: {
        required,
      },
      carNo: {
        required,
        carNoCheck: or(carNoRegex, carNoRegexDipl),
      },
    }
  },

  components: {
    DatePicker,
  },

  mounted() {
    if (!this.$route.params.data) {
      alert('잘못된 접근입니다.');
      this.$router.push('/discountvehicle');
      return;
    }
    this.getDiscountList();
  },

  methods: {

    async getDiscountList() {
      const res = await axios('get', '/api/prepay/getDiscountList.json');
      this.discountList = res.data.discountList;
    },

    emitSetDate(startDate, endDate) {
      this.data.startDt = startDate;
      this.data.endDt = endDate;
    },

    async updateBtn() {
      if (this.$v.$invalid) {
        alert('입력하신 정보를 다시 한번 확인해주세요');
        return;
      }

      const apiParams = new FormData();
      apiParams.append('carNo', this.data.carNo.replace(/\s/gi, ''));
      apiParams.append('seqId', this.data.seqId);

      const res = await axios('post', '/api/admin/discount/carNoCheck.json', apiParams);
      const data = res.data.result.result.result;
      if (!data) {
        alert('이미 등록중인 차량입니다.');
        return;
      }

      const discountParams = new FormData();
      discountParams.append('carNo', this.data.carNo.replace(/\s/gi, ''));
      discountParams.append('seqId', this.data.seqId);
      discountParams.append('carOwnerNm', this.data.carOwnerNm);
      discountParams.append('startDt', this.data.startDt);
      discountParams.append('endDt', this.data.endDt);
      discountParams.append('discountCd', this.data.discountCd);
      discountParams.append('note', this.data.note);
      await axios('post', '/api/admin/discount/update.json', discountParams);
      this.$router.push('discountvehicle');
    },
  },
};
</script>
